<template>
  <div class="question-editor">
    <div class="question-pd">
      <!-- 题目头部 -->
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <span v-if="isMust" class="asterisk">*</span>
            <span class="question-number">
              {{
                `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
              }}
            </span>
          </div>
          <div class="question-select">
            <span>手写签名</span>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>

      <!-- 题目标题输入框 -->
      <div
        class="textarea-box"
        :style="{
          border:
            isFocusIndex === '-1'
              ? '1px solid rgba(58,96,255,0.5)'
              : '1px solid #DCDDE0',
        }"
      >
        <!-- <textarea
          class="case-problem-textarea"
          v-model.lazy="caseProblem"
          placeholder="请输入题目标题"
          maxlength="500"
          :disabled="dataObj.disabled"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          @input="handleUpdate"
        ></textarea>
        <div class="textarea-footer">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div> -->
        <MyEditor
          v-model="caseProblem"
          placeholder="请输入题目标题"
          @insertImg="handleCaseProblemImg"
          @input="handleInput"
        />
      </div>

      <!-- 题目封面图片 -->
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" style="width: 100%; border-radius: 4px" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>

      <!-- 签名区域 -->
      <div class="sign-view" @click="openSignature">
        <img
          src="https://ossfastmake.mustke.com/wenjuan/tupian/signature-1767493390422.svg"
          class="sign-image"
        />
        <span class="sign-text">点击此处签名</span>
      </div>

      <!-- 图片预览弹窗（替代小程序自定义弹窗） -->
      <el-dialog
        title="图片预览"
        :visible.sync="fangdaShow"
        width="60%"
        @close="fangdaClose"
        append-to-body
      >
        <div class="popup-scroll">
          <img :src="fangdaImgUrl" style="width: 100%" />
        </div>
      </el-dialog>

      <!-- 必选题设置 -->
      <div class="add-view custom-check-box">
        <div class="required custom-check-box">
          <el-checkbox
            v-model="isMust"
            label="必选题"
            size="mini"
            @change="handleUpdate"
          ></el-checkbox>
        </div>
        <div></div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="question-footer">
      <div class="save-btn" @click="saveClick">保存</div>
    </div>

    <!-- 隐藏的文件上传输入框（替代uploadImage组件） -->
    <input
      ref="uploadInput"
      type="file"
      accept="image/*"
      class="hidden-upload"
      @change="handleFileUpload"
    />

    <!-- 签名弹窗（Web端可扩展：集成签名插件如signature_pad） -->
    <el-dialog
      title="手写签名"
      :visible.sync="showSign"
      width="80%"
      append-to-body
    >
      <div>
        <!-- 这里可集成 signature_pad 实现Web端手写签名，示例占位 -->
        <div
          id="signature-pad"
          style="width: 100%; height: 300px; border: 1px solid #ddd"
        ></div>
        <div
          style="
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
            gap: 10px;
          "
        >
          <el-button size="mini" @click="clearSignature">清空</el-button>
          <el-button size="mini" type="primary" @click="saveSignature"
            >确认签名</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 可选：引入签名插件（需先安装 npm install signature_pad）
// import SignaturePad from 'signature_pad'
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
export default {
  name: "QuestionSignature",
  // Vue2 定义Props
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    updateType: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      dataObj: {},
      isMust: false,
      showpopup: false,
      showUpload: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      showSign: false, // 签名弹窗开关
      // 替代 Vue3 ref
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      // 签名插件实例（可选）
      signaturePad: null,
    };
  },
  // Vue2 监听属性
  watch: {
    params: {
      handler(newValue) {
        this.dataObj = { ...newValue };
        this.caseProblem = newValue.caseProblem || "";
        this.isMust = newValue.isMust === 1;
        this.images = JSON.parse(newValue.caseProblemImg || "[]");
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // 初始化签名插件（可选）
    // const canvas = document.getElementById('signature-pad')
    // this.signaturePad = new SignaturePad(canvas)
  },
  methods: {
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    // 清空题目标题
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    // 触发封面图片上传
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.uploadInput.click();
    },
    // 处理文件上传（替代uploadImage组件）
    async handleFileUpload(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          this.images = [response.data.urls];
          this.handleUpdate();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    // 兼容原上传完成方法
    handleUploadComplete(e) {
      console.log("上传完成：", e);
      if (this.uploadIndex === -1) {
        this.images = e;
      } else {
        if (!this.list) this.list = [];
        this.list[this.uploadIndex].img_path = e;
      }
      this.showUpload = false;
      this.handleUpdate();
    },
    // 删除封面图片
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdate();
    },
    // 取消按钮
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 保存按钮
    saveClick() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.caseProblem = this.caseProblem || "请输入题目标题";

      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 触发更新事件
    handleUpdate() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.caseProblem = this.caseProblem;

      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 图片预览
    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text || "";
    },
    // 关闭图片预览
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
    // 打开签名弹窗
    openSignature() {
      this.showSign = true;
    },
    // 清空签名（可选）
    clearSignature() {
      // if (this.signaturePad) this.signaturePad.clear()
    },
    // 保存签名（可选）
    saveSignature() {
      // if (this.signaturePad) {
      //   const dataUrl = this.signaturePad.toDataURL() // 获取签名base64
      //   // 上传签名图片逻辑
      //   this.showSign = false
      //   this.$message.success('签名成功')
      // }
      this.showSign = false;
      this.$message.success("签名成功（示例）");
    },
  },
};
</script>

<style lang="scss" scoped>
// 题目头部
.question-header {
  display: flex;
  margin-bottom: 10px;
}

.asterisk {
  color: #ff4d4f;
  margin-right: 4px;
}

.question-number {
  font-size: 14px;
  color: #4c4a56;
}

.question-select {
  background: #f0f0f0;
  padding: 4px 8px;
  border-radius: 4px;
  margin-left: 8px;
  font-size: 14px;
  color: #666;
}

// 题目标题输入框
.textarea-box {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  padding: 7px 8px 5px;
  box-sizing: border-box;
  margin-top: 11px;
}

.case-problem-textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font-size: 14px;
  color: #4c4a56;
  min-height: 60px;
}

.textarea-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}

.clear-btn {
  width: 31px;
  height: 18px;
  background: #ffffff;
  border: 1px solid #3a60ff;
  border-radius: 2.5px;
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #3a60ff;
  line-height: 18px;
  margin-left: 5.5px;
  cursor: pointer;
}

// 题目封面图片
.question-images {
  margin-top: 10px;
}

.guanbi {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  z-index: 10;
}

// 签名区域
.sign-view {
  width: 100%;
  height: 220px; // 440rpx → 220px
  border: 1px solid #dcdde0;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f6f6f6;
  margin-top: 10px;
  cursor: pointer;

  .sign-image {
    width: 26px; // 52rpx → 26px
    height: 27px; // 54rpx → 27px
    margin-top: 90px; // 180rpx → 90px
  }

  .sign-text {
    font-size: 14px; // 28rpx → 14px
    font-weight: 400;
    text-align: center;
    color: #798497;
    margin-top: 11px; // 22rpx → 11px
  }
}

// 操作栏
.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

// 隐藏上传框
.hidden-upload {
  display: none;
}

// 预览弹窗内容
.popup-scroll {
  width: 100%;
  padding: 10px;

  img {
    max-width: 100%;
    max-height: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditSignature.vue